module.exports = __webpack_public_path__ + "img/nemotron-compression-knee.a05049a7.png";